import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MostPopularItemsComponent } from './most-popular-items.component';
import { DebounceClickDirectiveModule } from '../../../directives/debounce-click/debounce-click-directive.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [MostPopularItemsComponent],
  imports: [
    CommonModule,
    IonicModule,
    DebounceClickDirectiveModule,
    FontAwesomeModule
  ],
  exports: [MostPopularItemsComponent]
})
export class MostPopularItemsComponentModule {}
